import toast from "react-hot-toast";
import { axiosInstance } from "./api.service";
import authHeader from "./auth.header";

const register = async (newUser) => {
	try {
		const res = await axiosInstance.post("/auth/signup", newUser, {
			headers: authHeader(),
		});

		if (res.data.success === true) {
			toast.success(res.data.msg);
			window.location.reload();
		}
	} catch (err) {
		if (err.response && err.response.status === 401) {
			toast.error(err.msg);
		}
		toast.error(err.response.data.msg);
	}
};

const reset = async (userInput) => {
	try {
		const res = await axiosInstance.post("/auth/reset", userInput, {
			headers: authHeader(),
		});

		if (res.data.success === true) {
			toast.success(res.data.msg);
		}
	} catch (err) {
		if (err.response && err.response.status === 401) {
			toast.error(err.msg);
		}
		toast.error(err.response.data.msg);
	}
};

const login = async ({ userInput, password }, dispatch, history) => {
	dispatch({ type: "LOGIN_START" });
	try {
		const res = await axiosInstance.post("/auth/signin", {
			userInput,
			password,
		});
		if (res.data.success === true) {
			dispatch({ type: "LOGIN_SUCCESS", payload: res.data });
			history.replace("/board/projects");
			window.location.reload()
		}
	} catch (err) {
		dispatch({ type: "LOGIN_FAILURE", payload: err });
		if (err.response && err.response.data.msg) {
			return toast.error(err.response.data.msg);
		}
	}
};

const logOut = (history) => {
	localStorage.removeItem("user");
	history.replace("/");
	window.location.reload()
};

const AuthService = {
	register,
	reset,
	login,
	logOut,
};

export default AuthService;
